import { render, staticRenderFns } from "./reportPayFeeDetailList.vue?vue&type=template&id=2ad35d1b&scoped=true"
import script from "./reportPayFeeDetailList.vue?vue&type=script&lang=js"
export * from "./reportPayFeeDetailList.vue?vue&type=script&lang=js"
import style0 from "./reportPayFeeDetailList.vue?vue&type=style&index=0&id=2ad35d1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad35d1b",
  null
  
)

export default component.exports